import React, { useState, useEffect } from 'react';
import {
  HardDrive,
  Folder,
  FileText,
  Download,
  Upload,
  Search,
  ChevronRight,
  ChevronDown,
  File,
  Image,
  FileCode,
  FilePlus,
  Trash2,
  RefreshCw,
  FolderPlus,
  Share2,
  Users,
  FolderOpen,
  X,
  Edit3,
  Home,
  ArrowLeft
} from 'lucide-react';

// Tipos de archivo con iconos
const FILE_ICONS = {
  folder: Folder,
  pdf: FileText,
  doc: FileText,
  docx: FileText,
  xls: FileText,
  xlsx: FileText,
  jpg: Image,
  jpeg: Image,
  png: Image,
  gif: Image,
  js: FileCode,
  ts: FileCode,
  json: FileCode,
  default: File
};

// Carpetas GENERAL compartidas entre departamentos
const GENERAL_FOLDERS = [
  { id: 'general_gerencia', name: 'Gerencia', icon: Folder, color: 'text-blue-500', shared: true },
  { id: 'general_administracion', name: 'Administración', icon: Folder, color: 'text-blue-500', shared: true },
  { id: 'general_comercial', name: 'Comercial', icon: Folder, color: 'text-blue-500', shared: true },
  { id: 'general_produccion', name: 'Producción', icon: Folder, color: 'text-blue-500', shared: true },
  { id: 'general_sat', name: 'SAT', icon: Folder, color: 'text-blue-500', shared: true },
  { id: 'general_desarrollo', name: 'Desarrollo', icon: Folder, color: 'text-blue-500', shared: true },
  { id: 'general_marketing', name: 'Marketing', icon: Folder, color: 'text-blue-500', shared: true },
  { id: 'general_rrhh', name: 'RRHH', icon: Folder, color: 'text-blue-500', shared: true }
];

// Categorías de archivos privados por departamento
const CATEGORIES = [
  { id: 'drivers', name: 'Drivers', icon: HardDrive, color: 'text-blue-500' },
  { id: 'manuales', name: 'Manuales', icon: FileText, color: 'text-blue-500' },
  { id: 'software', name: 'Software', icon: FileCode, color: 'text-blue-500' },
  { id: 'documentos', name: 'Documentos', icon: Folder, color: 'text-blue-500' }
];

// Colores para departamentos
const DEPT_COLORS = {
  'Gerencia': { bg: 'bg-red-100', hover: 'hover:bg-red-200', active: 'bg-red-500', icon: 'text-red-500', border: 'border-red-200' },
  'Administracion': { bg: 'bg-blue-100', hover: 'hover:bg-blue-200', active: 'bg-blue-500', icon: 'text-blue-500', border: 'border-blue-200' },
  'Comercial': { bg: 'bg-green-100', hover: 'hover:bg-green-200', active: 'bg-green-500', icon: 'text-green-500', border: 'border-green-200' },
  'SAT': { bg: 'bg-orange-100', hover: 'hover:bg-orange-200', active: 'bg-orange-500', icon: 'text-orange-500', border: 'border-orange-200' },
  'Soporte Tecnico': { bg: 'bg-orange-100', hover: 'hover:bg-orange-200', active: 'bg-orange-500', icon: 'text-orange-500', border: 'border-orange-200' },
  'Produccion': { bg: 'bg-purple-100', hover: 'hover:bg-purple-200', active: 'bg-purple-500', icon: 'text-purple-500', border: 'border-purple-200' },
  'Desarrollo': { bg: 'bg-cyan-100', hover: 'hover:bg-cyan-200', active: 'bg-cyan-500', icon: 'text-cyan-500', border: 'border-cyan-200' },
  'Marketing': { bg: 'bg-pink-100', hover: 'hover:bg-pink-200', active: 'bg-pink-500', icon: 'text-pink-500', border: 'border-pink-200' },
  'RRHH': { bg: 'bg-yellow-100', hover: 'hover:bg-yellow-200', active: 'bg-yellow-500', icon: 'text-yellow-500', border: 'border-yellow-200' },
  'Proyectos': { bg: 'bg-indigo-100', hover: 'hover:bg-indigo-200', active: 'bg-indigo-500', icon: 'text-indigo-500', border: 'border-indigo-200' },
  'Almacen': { bg: 'bg-teal-100', hover: 'hover:bg-teal-200', active: 'bg-teal-500', icon: 'text-teal-500', border: 'border-teal-200' },
  'default': { bg: 'bg-gray-100', hover: 'hover:bg-gray-200', active: 'bg-gray-500', icon: 'text-gray-500', border: 'border-gray-200' }
};

export default function ServerPanel({ user }) {
  const [activeCategory, setActiveCategory] = useState('general_gerencia');
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isGeneralSection, setIsGeneralSection] = useState(true);
  const [isDeptSection, setIsDeptSection] = useState(false);
  const [generalExpanded, setGeneralExpanded] = useState(false);
  const [deptExpanded, setDeptExpanded] = useState(false);
  const [recursosExpanded, setRecursosExpanded] = useState(false);
  const [showNewFolderModal, setShowNewFolderModal] = useState(false);
  const [newFolderName, setNewFolderName] = useState('');
  const [userFolders, setUserFolders] = useState([]);

  // Navegación de carpetas (breadcrumbs)
  const [currentPath, setCurrentPath] = useState([]); // Array de {id, name}
  const [currentFolderContents, setCurrentFolderContents] = useState({ folders: [], files: [] });

  // Modal renombrar carpeta
  const [showRenameModal, setShowRenameModal] = useState(false);
  const [renamingFolder, setRenamingFolder] = useState(null);
  const [newName, setNewName] = useState('');

  // Modal renombrar archivo
  const [showRenameFileModal, setShowRenameFileModal] = useState(false);
  const [renamingFile, setRenamingFile] = useState(null);
  const [newFileName, setNewFileName] = useState('');

  // Crear carpeta dentro de otra
  const [creatingInPath, setCreatingInPath] = useState(null);

  // Subida de archivos
  const [isDragging, setIsDragging] = useState(false);
  const [uploadingFiles, setUploadingFiles] = useState([]);
  const fileInputRef = React.useRef(null);

  // Mapeo de roles/departamentos a nombres de departamento
  const DEPT_NAME_MAP = {
    'comercial': 'Comercial',
    'sat': 'SAT',
    'soporte': 'SAT',
    'soporte_tecnico': 'SAT',
    'soporte tecnico': 'SAT',
    'gerencia': 'Gerencia',
    'administracion': 'Administracion',
    'produccion': 'Produccion',
    'desarrollo': 'Desarrollo',
    'marketing': 'Marketing',
    'rrhh': 'RRHH',
    'proyectos': 'Proyectos',
    'almacen': 'Almacen'
  };

  // Obtener departamento del usuario - MEJORADO v2
  const getUserDept = () => {
    // Intentar múltiples formatos posibles
    let deptName = null;

    // Debug: mostrar estructura del usuario (quitar en producción)
    // console.log('User object:', JSON.stringify(user, null, 2));

    // 1. Directo del objeto user
    if (user?.department) deptName = user.department;

    // 2. Array de departamentos
    if (!deptName && user?.departments) {
      if (Array.isArray(user.departments) && user.departments.length > 0) {
        const first = user.departments[0];
        deptName = typeof first === 'string' ? first : first?.name;
      }
    }

    // 3. user_departments puede tener varias estructuras
    if (!deptName && user?.user_departments) {
      const ud = user.user_departments[0];
      if (ud) {
        deptName = ud.department?.name || ud.departments?.name || ud.name || (typeof ud === 'string' ? ud : null);
      }
    }

    // 4. Buscar en role_departments
    if (!deptName && user?.role_departments?.[0]?.department) {
      deptName = user.role_departments[0].department;
    }

    // 5. Buscar en department_name directo
    if (!deptName && user?.department_name) {
      deptName = user.department_name;
    }

    // 6. Buscar en dept (abreviado)
    if (!deptName && user?.dept) {
      deptName = user.dept;
    }

    // Si encontramos algo, normalizar
    if (deptName) {
      const deptLower = deptName.toLowerCase().replace(/[_\s]+/g, '_');
      // Buscar en el mapa
      for (const [key, value] of Object.entries(DEPT_NAME_MAP)) {
        if (deptLower.includes(key) || key.includes(deptLower)) {
          return value;
        }
      }
      // Capitalizar primera letra si no está en el mapa
      return deptName.charAt(0).toUpperCase() + deptName.slice(1);
    }

    // Mapeo por rol si no hay departamento explícito
    const roleMap = {
      'superadmin': 'Comercial',  // CAMBIADO: superadmin ve Comercial por defecto
      'admin': 'Comercial',       // CAMBIADO: admin ve Comercial por defecto
      'usuario': 'Comercial',
      'revisor': 'Comercial',
      'tecnico': 'SAT',
      'tecnico_externo': 'SAT',
      'franquiciado': 'Comercial',
      'cliente_final': 'Comercial',
      'cuenta_cliente': 'Comercial'
    };

    if (user?.role && roleMap[user.role]) {
      return roleMap[user.role];
    }

    // Fallback: Comercial en vez de General
    return 'Comercial';
  };
  const userDept = getUserDept();
  const deptColors = DEPT_COLORS[userDept] || DEPT_COLORS['default'];

  // Subcarpetas del departamento del usuario
  const DEPT_SUBFOLDERS = [
    { id: 'dept_documentos', name: 'Documentos', icon: FileText },
    { id: 'dept_proyectos', name: 'Proyectos', icon: Folder },
    { id: 'dept_informes', name: 'Informes', icon: FileText },
    { id: 'dept_plantillas', name: 'Plantillas', icon: File }
  ];

  // Permisos: Solo revisor, admin y superadmin pueden subir a Recursos Técnicos
  const canUploadToRecursos = user?.role && ['revisor', 'admin', 'superadmin'].includes(user.role);

  // Cargar archivos (mock por ahora)
  useEffect(() => {
    loadFiles();
  }, [activeCategory]);

  const loadFiles = async () => {
    setLoading(true);
    // Mock data - en producción conectar con API /api/files
    const mockFiles = {
      // Carpetas GENERAL compartidas
      general_gerencia: [
        { id: 100, name: 'Comunicado_Oficial_2026.pdf', type: 'pdf', size: '1.2 MB', date: '2026-01-17', uploadedBy: 'Director General' },
        { id: 101, name: 'Objetivos_Anuales.xlsx', type: 'xlsx', size: '456 KB', date: '2026-01-15', uploadedBy: 'Gerencia' },
        { id: 102, name: 'Presentacion_Resultados_Q4.pptx', type: 'pptx', size: '8.2 MB', date: '2026-01-10', uploadedBy: 'CEO' }
      ],
      general_administracion: [
        { id: 110, name: 'Plantilla_Gastos_2026.xlsx', type: 'xlsx', size: '234 KB', date: '2026-01-16', uploadedBy: 'Contabilidad' },
        { id: 111, name: 'Procedimiento_Facturacion.pdf', type: 'pdf', size: '890 KB', date: '2026-01-14', uploadedBy: 'Administración' },
        { id: 112, name: 'Calendario_Fiscal_2026.pdf', type: 'pdf', size: '320 KB', date: '2026-01-12', uploadedBy: 'Fiscal' }
      ],
      general_comercial: [
        { id: 120, name: 'Catalogo_Productos_2026.pdf', type: 'pdf', size: '15.4 MB', date: '2026-01-17', uploadedBy: 'Marketing' },
        { id: 121, name: 'Tarifas_Vigentes.xlsx', type: 'xlsx', size: '567 KB', date: '2026-01-16', uploadedBy: 'Comercial' },
        { id: 122, name: 'Presentacion_Clientes.pptx', type: 'pptx', size: '12.3 MB', date: '2026-01-15', uploadedBy: 'Ventas' }
      ],
      general_produccion: [
        { id: 130, name: 'Planning_Produccion_Enero.xlsx', type: 'xlsx', size: '678 KB', date: '2026-01-17', uploadedBy: 'Jefe Producción' },
        { id: 131, name: 'Manual_Calidad_ISO.pdf', type: 'pdf', size: '4.5 MB', date: '2026-01-10', uploadedBy: 'Calidad' },
        { id: 132, name: 'Fichas_Tecnicas_Productos.zip', type: 'zip', size: '23.4 MB', date: '2026-01-08', uploadedBy: 'Producción' }
      ],
      general_sat: [
        { id: 140, name: 'Guia_Soporte_Tecnico.pdf', type: 'pdf', size: '2.3 MB', date: '2026-01-17', uploadedBy: 'SAT Manager' },
        { id: 141, name: 'Configuraciones_Tipo.zip', type: 'zip', size: '45.6 MB', date: '2026-01-15', uploadedBy: 'Técnico Senior' },
        { id: 142, name: 'FAQs_Clientes.pdf', type: 'pdf', size: '1.8 MB', date: '2026-01-12', uploadedBy: 'Soporte' }
      ],
      general_desarrollo: [
        { id: 150, name: 'Documentacion_API.pdf', type: 'pdf', size: '3.4 MB', date: '2026-01-17', uploadedBy: 'Tech Lead' },
        { id: 151, name: 'Roadmap_2026.xlsx', type: 'xlsx', size: '234 KB', date: '2026-01-16', uploadedBy: 'PM' },
        { id: 152, name: 'Guia_Estilos_Codigo.md', type: 'md', size: '45 KB', date: '2026-01-14', uploadedBy: 'Desarrollo' }
      ],
      general_marketing: [
        { id: 160, name: 'Kit_Marca_2026.zip', type: 'zip', size: '156 MB', date: '2026-01-17', uploadedBy: 'Diseño' },
        { id: 161, name: 'Plan_Marketing_Q1.pdf', type: 'pdf', size: '5.6 MB', date: '2026-01-15', uploadedBy: 'Marketing' },
        { id: 162, name: 'Plantillas_RRSS.psd', type: 'psd', size: '34.5 MB', date: '2026-01-13', uploadedBy: 'Social Media' }
      ],
      general_rrhh: [
        { id: 170, name: 'Manual_Bienvenida.pdf', type: 'pdf', size: '2.1 MB', date: '2026-01-17', uploadedBy: 'RRHH' },
        { id: 171, name: 'Politicas_Empresa.pdf', type: 'pdf', size: '890 KB', date: '2026-01-14', uploadedBy: 'RRHH' },
        { id: 172, name: 'Calendario_Vacaciones_2026.xlsx', type: 'xlsx', size: '234 KB', date: '2026-01-10', uploadedBy: 'RRHH' }
      ],
      // Carpetas del departamento del usuario (privadas)
      dept_documentos: [
        { id: 200, name: 'Procedimientos_Internos.pdf', type: 'pdf', size: '1.5 MB', date: '2026-01-17', uploadedBy: 'Equipo' },
        { id: 201, name: 'Contactos_Proveedores.xlsx', type: 'xlsx', size: '345 KB', date: '2026-01-15', uploadedBy: 'Responsable' },
        { id: 202, name: 'Notas_Reunion_Enero.docx', type: 'docx', size: '123 KB', date: '2026-01-14', uploadedBy: 'Equipo' }
      ],
      dept_proyectos: [
        { id: 210, name: 'Proyecto_Cliente_ABC.zip', type: 'zip', size: '45.6 MB', date: '2026-01-16', uploadedBy: 'PM' },
        { id: 211, name: 'Propuesta_Comercial_XYZ.pdf', type: 'pdf', size: '2.3 MB', date: '2026-01-14', uploadedBy: 'Comercial' },
        { id: 212, name: 'Planning_Q1_2026.xlsx', type: 'xlsx', size: '567 KB', date: '2026-01-12', uploadedBy: 'Responsable' }
      ],
      dept_informes: [
        { id: 220, name: 'Informe_Semanal_W3.pdf', type: 'pdf', size: '890 KB', date: '2026-01-17', uploadedBy: 'Analista' },
        { id: 221, name: 'Metricas_Enero.xlsx', type: 'xlsx', size: '234 KB', date: '2026-01-15', uploadedBy: 'Responsable' },
        { id: 222, name: 'Resumen_Actividad.pdf', type: 'pdf', size: '456 KB', date: '2026-01-13', uploadedBy: 'Equipo' }
      ],
      dept_plantillas: [
        { id: 230, name: 'Plantilla_Informe.docx', type: 'docx', size: '123 KB', date: '2026-01-10', uploadedBy: 'Admin' },
        { id: 231, name: 'Plantilla_Presupuesto.xlsx', type: 'xlsx', size: '89 KB', date: '2026-01-08', uploadedBy: 'Admin' },
        { id: 232, name: 'Plantilla_Email.html', type: 'html', size: '12 KB', date: '2026-01-05', uploadedBy: 'Marketing' }
      ],
      // Categorías privadas
      drivers: [
        { id: 1, name: 'Driver_Impresora_Epson_TM88.zip', type: 'zip', size: '2.4 MB', date: '2026-01-15' },
        { id: 2, name: 'Driver_Lector_Barras_Honeywell.exe', type: 'exe', size: '5.1 MB', date: '2026-01-10' },
        { id: 3, name: 'Pinpad_Ingenico_Driver.msi', type: 'msi', size: '12.8 MB', date: '2026-01-08' }
      ],
      manuales: [
        { id: 4, name: 'Manual_Taquilla_v3.2.pdf', type: 'pdf', size: '4.2 MB', date: '2026-01-12' },
        { id: 5, name: 'Guia_Rapida_Infoticketing.pdf', type: 'pdf', size: '1.8 MB', date: '2026-01-14' },
        { id: 6, name: 'Manual_Técnico_Hardware.pdf', type: 'pdf', size: '8.5 MB', date: '2026-01-05' }
      ],
      software: [
        { id: 7, name: 'Infoticketing_Taquilla_v3.2.1.exe', type: 'exe', size: '45.2 MB', date: '2026-01-16' },
        { id: 8, name: 'Actualizador_DB_v2.0.exe', type: 'exe', size: '3.4 MB', date: '2026-01-13' },
        { id: 9, name: 'Config_Tool_v1.5.zip', type: 'zip', size: '890 KB', date: '2026-01-11' }
      ],
      documentos: [
        { id: 10, name: 'Contrato_Tipo_Franquicia.docx', type: 'docx', size: '245 KB', date: '2026-01-09' },
        { id: 11, name: 'Listado_Precios_2026.xlsx', type: 'xlsx', size: '156 KB', date: '2026-01-07' },
        { id: 12, name: 'Procedimiento_Instalacion.pdf', type: 'pdf', size: '2.1 MB', date: '2026-01-06' }
      ]
    };

    setTimeout(() => {
      setFiles(mockFiles[activeCategory] || []);
      setLoading(false);
    }, 300);
  };

  const handleCategoryChange = (catId, isGeneral, isDept = false) => {
    setActiveCategory(catId);
    setIsGeneralSection(isGeneral);
    setIsDeptSection(isDept);
  };

  const getFileIcon = (type) => {
    const Icon = FILE_ICONS[type] || FILE_ICONS.default;
    return Icon;
  };

  const filteredFiles = files.filter(file =>
    file.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleDownload = (file) => {
    // En producción: llamar a API para descargar
    console.log('Descargando:', file.name);
    alert(`Descarga iniciada: ${file.name}`);
  };

  // Eliminar archivo
  const handleDeleteFile = (file) => {
    if (!window.confirm(`¿Eliminar "${file.name}"?`)) return;
    // En producción: llamar a API para eliminar
    setFiles(prev => prev.filter(f => f.id !== file.id));
    console.log('Archivo eliminado:', file.name);
  };

  // Abrir modal para renombrar archivo
  const openRenameFileModal = (file) => {
    setRenamingFile(file);
    setNewFileName(file.name);
    setShowRenameFileModal(true);
  };

  // Renombrar archivo
  const renameFile = () => {
    if (!newFileName.trim() || !renamingFile) return;
    setFiles(prev => prev.map(f =>
      f.id === renamingFile.id
        ? { ...f, name: newFileName.trim(), type: newFileName.split('.').pop().toLowerCase() }
        : f
    ));
    setShowRenameFileModal(false);
    setRenamingFile(null);
    setNewFileName('');
  };

  // Estructura de carpetas anidadas (almacenada como árbol)
  // Cada carpeta tiene: id, name, parentId (null si es raíz), children: [], files: []
  const [folderTree, setFolderTree] = useState({});

  // Crear nueva carpeta - ahora soporta crear dentro de otra carpeta
  const createNewFolder = () => {
    if (!newFolderName.trim()) return;
    const newFolder = {
      id: `user_folder_${Date.now()}`,
      name: newFolderName.trim(),
      icon: Folder,
      isUserCreated: true,
      parentId: creatingInPath ? creatingInPath[creatingInPath.length - 1]?.id : null,
      children: [],
      files: []
    };

    if (creatingInPath && creatingInPath.length > 0) {
      // Crear dentro de una carpeta existente
      setUserFolders(prev => {
        const updateChildren = (folders) => {
          return folders.map(f => {
            if (f.id === newFolder.parentId) {
              return { ...f, children: [...(f.children || []), newFolder] };
            }
            if (f.children && f.children.length > 0) {
              return { ...f, children: updateChildren(f.children) };
            }
            return f;
          });
        };
        return updateChildren(prev);
      });
    } else {
      // Crear en raíz del departamento
      setUserFolders(prev => [...prev, newFolder]);
    }

    setNewFolderName('');
    setShowNewFolderModal(false);
    setCreatingInPath(null);
  };

  // Eliminar carpeta del usuario (y sus hijos)
  const deleteUserFolder = (folderId) => {
    if (!window.confirm('¿Eliminar esta carpeta y todo su contenido?')) return;
    setUserFolders(prev => {
      const removeFolder = (folders) => {
        return folders.filter(f => f.id !== folderId).map(f => ({
          ...f,
          children: f.children ? removeFolder(f.children) : []
        }));
      };
      return removeFolder(prev);
    });
    // Si estamos dentro de la carpeta eliminada, volver al inicio
    if (currentPath.some(p => p.id === folderId)) {
      setCurrentPath([]);
    }
  };

  // Renombrar carpeta
  const renameFolder = () => {
    if (!newName.trim() || !renamingFolder) return;
    setUserFolders(prev => {
      const updateName = (folders) => {
        return folders.map(f => {
          if (f.id === renamingFolder.id) {
            return { ...f, name: newName.trim() };
          }
          if (f.children && f.children.length > 0) {
            return { ...f, children: updateName(f.children) };
          }
          return f;
        });
      };
      return updateName(prev);
    });
    // Actualizar breadcrumbs si la carpeta renombrada está en el path
    setCurrentPath(prev => prev.map(p =>
      p.id === renamingFolder.id ? { ...p, name: newName.trim() } : p
    ));
    setShowRenameModal(false);
    setRenamingFolder(null);
    setNewName('');
  };

  // Navegar dentro de una carpeta
  const navigateToFolder = (folder) => {
    setCurrentPath(prev => [...prev, { id: folder.id, name: folder.name }]);
  };

  // Navegar a un punto específico del breadcrumb
  const navigateToBreadcrumb = (index) => {
    if (index < 0) {
      setCurrentPath([]);
    } else {
      setCurrentPath(prev => prev.slice(0, index + 1));
    }
  };

  // Volver a la carpeta anterior
  const navigateBack = () => {
    setCurrentPath(prev => prev.slice(0, -1));
  };

  // Obtener carpetas del nivel actual
  const getCurrentFolders = () => {
    if (currentPath.length === 0) {
      return userFolders;
    }
    // Buscar en el árbol la carpeta actual
    const findFolder = (folders, pathIndex) => {
      if (pathIndex >= currentPath.length) return folders;
      const target = folders.find(f => f.id === currentPath[pathIndex].id);
      if (!target) return [];
      if (pathIndex === currentPath.length - 1) {
        return target.children || [];
      }
      return findFolder(target.children || [], pathIndex + 1);
    };
    return findFolder(userFolders, 0);
  };

  // Abrir modal para crear carpeta dentro de la ruta actual
  const openCreateFolderInCurrent = () => {
    setCreatingInPath(currentPath.length > 0 ? currentPath : null);
    setShowNewFolderModal(true);
  };

  // Abrir modal para renombrar
  const openRenameModal = (folder) => {
    setRenamingFolder(folder);
    setNewName(folder.name);
    setShowRenameModal(true);
  };

  // ========== FUNCIONES DE SUBIDA DE ARCHIVOS ==========

  // Manejar click en botón subir
  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  // Manejar selección de archivos
  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      uploadFiles(files);
    }
    // Reset input para permitir subir el mismo archivo de nuevo
    e.target.value = '';
  };

  // Manejar drag enter
  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  // Manejar drag leave
  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Solo desactivar si salimos del contenedor principal
    if (e.currentTarget.contains(e.relatedTarget)) return;
    setIsDragging(false);
  };

  // Manejar drag over
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  // Manejar drop
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const files = Array.from(e.dataTransfer.files);
    if (files.length > 0) {
      uploadFiles(files);
    }
  };

  // Subir archivos al servidor
  const uploadFiles = async (files) => {
    // Añadir archivos a la lista de subida con estado
    const newUploads = files.map(file => ({
      id: Date.now() + Math.random(),
      name: file.name,
      size: file.size,
      progress: 0,
      status: 'uploading', // uploading, success, error
      file: file
    }));

    setUploadingFiles(prev => [...prev, ...newUploads]);

    // Simular subida (en producción: usar API real)
    for (const upload of newUploads) {
      try {
        // Simular progreso
        for (let progress = 0; progress <= 100; progress += 20) {
          await new Promise(resolve => setTimeout(resolve, 200));
          setUploadingFiles(prev => prev.map(u =>
            u.id === upload.id ? { ...u, progress } : u
          ));
        }

        // Marcar como completado
        setUploadingFiles(prev => prev.map(u =>
          u.id === upload.id ? { ...u, status: 'success', progress: 100 } : u
        ));

        // Añadir a la lista de archivos (mock)
        const newFile = {
          id: Date.now(),
          name: upload.name,
          type: upload.name.split('.').pop().toLowerCase(),
          size: formatFileSize(upload.size),
          date: new Date().toISOString().split('T')[0],
          uploadedBy: user?.full_name || user?.name || 'Usuario'
        };
        setFiles(prev => [newFile, ...prev]);

        // Remover de la lista de subida después de 2 segundos
        setTimeout(() => {
          setUploadingFiles(prev => prev.filter(u => u.id !== upload.id));
        }, 2000);

      } catch (error) {
        console.error('Error subiendo archivo:', error);
        setUploadingFiles(prev => prev.map(u =>
          u.id === upload.id ? { ...u, status: 'error' } : u
        ));
      }
    }
  };

  // Formatear tamaño de archivo
  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  };

  return (
    <div className="h-full flex flex-col">
      {/* Header estilo Hetzner */}
      <div className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <HardDrive className="w-8 h-8 text-[#3B82F6]" />
            <div>
              <h1 className="text-xl font-semibold text-gray-900">Server</h1>
              <p className="text-sm text-gray-500">Archivos compartidos, drivers y software</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={loadFiles}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              title="Refrescar"
            >
              <RefreshCw className={`w-5 h-5 text-gray-500 ${loading ? 'animate-spin' : ''}`} />
            </button>
          </div>
        </div>
      </div>

      <div className="flex-1 flex overflow-hidden">
        {/* Sidebar estilo Hetzner */}
        <div className="w-64 bg-white border-r border-gray-200 overflow-y-auto">

          {/* GENERAL */}
          <div className="mt-2">
            <button
              onClick={() => setGeneralExpanded(!generalExpanded)}
              className="w-full flex items-center justify-between px-4 py-3 hover:bg-gray-50 transition-colors"
            >
              <div className="flex items-center gap-3">
                {generalExpanded ? (
                  <FolderOpen className="w-5 h-5 text-blue-500" />
                ) : (
                  <Folder className="w-5 h-5 text-blue-500" />
                )}
                <span className="text-sm font-semibold text-gray-800">GENERAL</span>
              </div>
              {generalExpanded ? (
                <ChevronDown className="w-4 h-4 text-gray-400" />
              ) : (
                <ChevronRight className="w-4 h-4 text-gray-400" />
              )}
            </button>

            {generalExpanded && (
              <nav className="pb-2">
                {GENERAL_FOLDERS.map((folder) => {
                  const Icon = folder.icon;
                  const isActive = activeCategory === folder.id;
                  return (
                    <button
                      key={folder.id}
                      onClick={() => handleCategoryChange(folder.id, true, false)}
                      className={`w-full flex items-center justify-between px-4 py-2 text-left transition-colors ${
                        isActive
                          ? 'bg-blue-50 text-blue-600 border-r-2 border-blue-500'
                          : 'text-gray-600 hover:bg-gray-50'
                      }`}
                    >
                      <div className="flex items-center gap-3 pl-6">
                        <Icon className={`w-4 h-4 ${isActive ? 'text-blue-500' : folder.color}`} />
                        <span className="text-sm">{folder.name}</span>
                      </div>
                      <Users className={`w-3 h-3 ${isActive ? 'text-blue-400' : 'text-gray-300'}`} />
                    </button>
                  );
                })}
              </nav>
            )}
          </div>

          {/* DEPARTAMENTO */}
          <div className="">
            <button
              onClick={() => setDeptExpanded(!deptExpanded)}
              className="w-full flex items-center justify-between px-4 py-3 hover:bg-gray-50 transition-colors"
            >
              <div className="flex items-center gap-3">
                {deptExpanded ? (
                  <FolderOpen className={`w-5 h-5 ${deptColors.icon}`} />
                ) : (
                  <Folder className={`w-5 h-5 ${deptColors.icon}`} />
                )}
                <span className="text-sm font-semibold text-gray-800">{userDept.toUpperCase()}</span>
              </div>
              {deptExpanded ? (
                <ChevronDown className="w-4 h-4 text-gray-400" />
              ) : (
                <ChevronRight className="w-4 h-4 text-gray-400" />
              )}
            </button>

            {deptExpanded && (
              <nav className="pb-2">
                {/* Carpetas predefinidas */}
                {DEPT_SUBFOLDERS.map((folder) => {
                  const Icon = folder.icon;
                  const isActive = activeCategory === folder.id;
                  return (
                    <button
                      key={folder.id}
                      onClick={() => handleCategoryChange(folder.id, false, true)}
                      className={`w-full flex items-center gap-3 px-4 py-2 text-left transition-colors ${
                        isActive
                          ? `${deptColors.bg} ${deptColors.icon} border-r-2 ${deptColors.border}`
                          : 'text-gray-600 hover:bg-gray-50'
                      }`}
                      style={isActive ? { borderRightColor: 'currentColor' } : {}}
                    >
                      <div className="flex items-center gap-3 pl-6">
                        <Icon className={`w-4 h-4 ${isActive ? deptColors.icon : 'text-gray-400'}`} />
                        <span className="text-sm">{folder.name}</span>
                      </div>
                    </button>
                  );
                })}

                {/* Carpetas creadas por el usuario */}
                {userFolders.map((folder) => {
                  const Icon = folder.icon || Folder;
                  const isActive = activeCategory === folder.id;
                  const hasChildren = folder.children && folder.children.length > 0;
                  return (
                    <div key={folder.id} className="flex items-center group">
                      <button
                        onClick={() => handleCategoryChange(folder.id, false, true)}
                        onDoubleClick={() => navigateToFolder(folder)}
                        className={`flex-1 flex items-center gap-3 px-4 py-2 text-left transition-colors ${
                          isActive
                            ? `${deptColors.bg} ${deptColors.icon} border-r-2`
                            : 'text-gray-600 hover:bg-gray-50'
                        }`}
                        title="Click: seleccionar | Doble click: entrar"
                      >
                        <div className="flex items-center gap-3 pl-6">
                          <Icon className={`w-4 h-4 ${isActive ? deptColors.icon : 'text-gray-400'}`} />
                          <span className="text-sm">{folder.name}</span>
                          {hasChildren && (
                            <span className="text-[10px] text-gray-400">({folder.children.length})</span>
                          )}
                        </div>
                      </button>
                      <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                        <button
                          onClick={() => openRenameModal(folder)}
                          className="flex items-center gap-1 px-2 py-1 text-xs bg-blue-50 hover:bg-blue-100 text-blue-600 rounded transition-colors"
                          title="Renombrar carpeta"
                        >
                          <Edit3 className="w-3 h-3" />
                          <span>Renombrar</span>
                        </button>
                        <button
                          onClick={() => deleteUserFolder(folder.id)}
                          className="flex items-center gap-1 px-2 py-1 text-xs bg-red-50 hover:bg-red-100 text-red-600 rounded transition-colors"
                          title="Eliminar carpeta"
                        >
                          <Trash2 className="w-3 h-3" />
                          <span>Borrar</span>
                        </button>
                      </div>
                    </div>
                  );
                })}

                {/* Botón crear nueva carpeta */}
                <button
                  onClick={() => setShowNewFolderModal(true)}
                  className="w-full flex items-center gap-3 px-4 py-2 text-left text-gray-400 hover:text-gray-600 hover:bg-gray-50 transition-colors"
                >
                  <div className="flex items-center gap-3 pl-6">
                    <FolderPlus className="w-4 h-4" />
                    <span className="text-sm">Nueva carpeta...</span>
                  </div>
                </button>
              </nav>
            )}
          </div>

          {/* RECURSOS TÉCNICOS */}
          <div className="">
            <button
              onClick={() => setRecursosExpanded(!recursosExpanded)}
              className="w-full flex items-center justify-between px-4 py-3 hover:bg-gray-50 transition-colors"
            >
              <div className="flex items-center gap-3">
                {recursosExpanded ? (
                  <FolderOpen className="w-5 h-5 text-purple-500" />
                ) : (
                  <Folder className="w-5 h-5 text-purple-500" />
                )}
                <span className="text-sm font-semibold text-gray-800">RECURSOS TÉCNICOS</span>
              </div>
              {recursosExpanded ? (
                <ChevronDown className="w-4 h-4 text-gray-400" />
              ) : (
                <ChevronRight className="w-4 h-4 text-gray-400" />
              )}
            </button>

            {recursosExpanded && (
              <nav className="pb-2">
                {CATEGORIES.map((cat) => {
                  const Icon = cat.icon;
                  const isActive = activeCategory === cat.id;
                  return (
                    <button
                      key={cat.id}
                      onClick={() => handleCategoryChange(cat.id, false, false)}
                      className={`w-full flex items-center gap-3 px-4 py-2 text-left transition-colors ${
                        isActive
                          ? 'bg-purple-50 text-purple-600 border-r-2 border-purple-500'
                          : 'text-gray-600 hover:bg-gray-50'
                      }`}
                    >
                      <div className="flex items-center gap-3 pl-6">
                        <Icon className={`w-4 h-4 ${isActive ? 'text-purple-500' : cat.color}`} />
                        <span className="text-sm">{cat.name}</span>
                      </div>
                    </button>
                  );
                })}
              </nav>
            )}
          </div>

          {/* Espacio usado - estilo Hetzner */}
          <div className="p-4">
            <div className="p-3 bg-gray-50 rounded-lg">
              <div className="flex items-center justify-between mb-2">
                <span className="text-xs text-gray-500">Espacio usado</span>
                <span className="text-xs font-medium text-gray-700">2.4 GB / 50 GB</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-1.5">
                <div className="bg-blue-500 h-1.5 rounded-full" style={{ width: '4.8%' }}></div>
              </div>
            </div>
          </div>
        </div>

        {/* Contenido principal */}
        <div className="flex-1 flex flex-col overflow-hidden">
          {/* Barra de búsqueda y acciones */}
          <div className="bg-white border-b border-gray-200 px-6 py-3">
            <div className="flex items-center justify-between">
              <div className="relative">
                <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  placeholder="Buscar archivos..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-9 pr-4 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-[#3B82F6] w-64"
                />
              </div>
              <div className="flex items-center gap-2">
                {/* Solo mostrar botón de subir si tiene permisos */}
                {(isGeneralSection || isDeptSection || canUploadToRecursos) && (
                  <>
                    <input
                      ref={fileInputRef}
                      type="file"
                      multiple
                      onChange={handleFileSelect}
                      className="hidden"
                    />
                    <button
                      onClick={handleUploadClick}
                      className="flex items-center gap-2 px-4 py-2 text-sm bg-blue-500 text-white hover:bg-blue-600 rounded-lg transition-colors"
                    >
                      <Upload className="w-4 h-4" />
                      Subir archivo
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* Indicador de carpeta compartida (GENERAL) */}
          {isGeneralSection && (
            <div className="bg-gray-100 border-b border-gray-200 px-6 py-2">
              <div className="flex items-center gap-2 text-gray-600">
                <Share2 className="w-4 h-4" />
                <span className="text-sm font-medium">
                  Carpeta compartida - Todos los departamentos pueden ver y subir archivos aquí
                </span>
              </div>
            </div>
          )}

          {/* Indicador de Recursos Técnicos (solo lectura para la mayoría) */}
          {!isGeneralSection && !isDeptSection && (
            <div className="bg-blue-50 border-b border-blue-200 px-6 py-2">
              <div className="flex items-center gap-2 text-blue-700">
                <HardDrive className="w-4 h-4" />
                <span className="text-sm font-medium">
                  {canUploadToRecursos
                    ? 'Recursos Técnicos - Puedes subir drivers, manuales y software'
                    : 'Recursos Técnicos - Solo lectura (contacta con SAT para subir archivos)'}
                </span>
              </div>
            </div>
          )}

          {/* Barra de navegación Breadcrumbs - SIEMPRE visible para carpetas del departamento */}
          {isDeptSection && (
            <div className="bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-200 px-6 py-2.5">
              <div className="flex items-center gap-2">
                {/* Botón Home */}
                <button
                  onClick={() => navigateToBreadcrumb(-1)}
                  className={`p-1.5 rounded-lg transition-colors ${currentPath.length === 0 ? 'bg-blue-100 text-blue-600' : 'hover:bg-gray-200 text-gray-500'}`}
                  title="Inicio del departamento"
                >
                  <Home className="w-4 h-4" />
                </button>

                {/* Botón Atrás - solo si hay path */}
                {currentPath.length > 0 && (
                  <button
                    onClick={navigateBack}
                    className="p-1.5 hover:bg-gray-200 rounded-lg transition-colors text-gray-500"
                    title="Subir un nivel"
                  >
                    <ArrowLeft className="w-4 h-4" />
                  </button>
                )}

                {/* Separador */}
                <div className="w-px h-5 bg-gray-300 mx-1" />

                {/* Breadcrumbs */}
                <div className="flex items-center gap-1 text-sm flex-1">
                  <button
                    onClick={() => navigateToBreadcrumb(-1)}
                    className={`px-2 py-1 rounded transition-colors ${currentPath.length === 0 ? 'bg-blue-500 text-white font-medium' : 'text-gray-600 hover:bg-gray-200'}`}
                  >
                    {userDept}
                  </button>
                  {currentPath.map((crumb, index) => (
                    <React.Fragment key={crumb.id}>
                      <ChevronRight className="w-4 h-4 text-gray-400" />
                      <button
                        onClick={() => navigateToBreadcrumb(index)}
                        className={`px-2 py-1 rounded transition-colors ${
                          index === currentPath.length - 1
                            ? 'bg-blue-500 text-white font-medium'
                            : 'text-gray-600 hover:bg-gray-200'
                        }`}
                      >
                        {crumb.name}
                      </button>
                    </React.Fragment>
                  ))}
                </div>

                {/* Botón crear subcarpeta */}
                <button
                  onClick={openCreateFolderInCurrent}
                  className="flex items-center gap-1.5 px-3 py-1.5 text-sm bg-blue-500 text-white hover:bg-blue-600 rounded-lg transition-colors"
                  title="Crear carpeta aquí"
                >
                  <FolderPlus className="w-4 h-4" />
                  <span>Nueva carpeta</span>
                </button>
              </div>
            </div>
          )}

          {/* Lista de carpetas y archivos - con Drag & Drop */}
          <div
            className={`flex-1 overflow-auto p-6 relative transition-colors ${isDragging ? 'bg-blue-50' : ''}`}
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
          >
            {/* Overlay de drag & drop */}
            {isDragging && (
              <div className="absolute inset-0 bg-blue-500/10 border-2 border-dashed border-blue-500 rounded-lg flex items-center justify-center z-10 pointer-events-none">
                <div className="bg-white rounded-xl shadow-lg p-8 text-center">
                  <Upload className="w-16 h-16 text-blue-500 mx-auto mb-4" />
                  <p className="text-xl font-semibold text-gray-800">Suelta los archivos aquí</p>
                  <p className="text-sm text-gray-500 mt-2">Se subirán a la carpeta actual</p>
                </div>
              </div>
            )}

            {/* Barra de progreso de subida */}
            {uploadingFiles.length > 0 && (
              <div className="mb-4 space-y-2">
                {uploadingFiles.map(upload => (
                  <div key={upload.id} className="bg-white border border-gray-200 rounded-lg p-3">
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex items-center gap-2">
                        <Upload className={`w-4 h-4 ${upload.status === 'success' ? 'text-green-500' : upload.status === 'error' ? 'text-red-500' : 'text-blue-500'}`} />
                        <span className="text-sm font-medium text-gray-700 truncate max-w-xs">{upload.name}</span>
                      </div>
                      <span className="text-xs text-gray-500">
                        {upload.status === 'success' ? '✓ Completado' : upload.status === 'error' ? '✗ Error' : `${upload.progress}%`}
                      </span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-1.5">
                      <div
                        className={`h-1.5 rounded-full transition-all ${upload.status === 'success' ? 'bg-green-500' : upload.status === 'error' ? 'bg-red-500' : 'bg-blue-500'}`}
                        style={{ width: `${upload.progress}%` }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}
            {loading ? (
              <div className="flex items-center justify-center h-full">
                <RefreshCw className="w-8 h-8 text-gray-400 animate-spin" />
              </div>
            ) : (
              <>
                {/* Mostrar carpetas del nivel actual (solo en sección departamento) */}
                {isDeptSection && getCurrentFolders().length > 0 && (
                  <div className="mb-6">
                    <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3 flex items-center gap-2">
                      <Folder className="w-4 h-4" />
                      Carpetas ({getCurrentFolders().length})
                    </h3>
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
                      {getCurrentFolders().map((folder) => (
                        <div
                          key={folder.id}
                          onDoubleClick={() => navigateToFolder(folder)}
                          className="group flex flex-col items-center p-4 bg-white border border-gray-200 rounded-xl hover:border-blue-300 hover:bg-blue-50 cursor-pointer transition-all"
                          title="Doble click para entrar"
                        >
                          <div className="relative mb-2">
                            <FolderOpen className="w-12 h-12 text-yellow-500 group-hover:text-yellow-600 transition-colors" />
                            {folder.children && folder.children.length > 0 && (
                              <span className="absolute -top-1 -right-1 bg-blue-500 text-white text-[10px] font-bold rounded-full w-5 h-5 flex items-center justify-center">
                                {folder.children.length}
                              </span>
                            )}
                          </div>
                          <span className="text-sm font-medium text-gray-700 text-center truncate w-full">{folder.name}</span>
                          <div className="flex items-center gap-1 mt-2 opacity-0 group-hover:opacity-100 transition-opacity">
                            <button
                              onClick={(e) => { e.stopPropagation(); openRenameModal(folder); }}
                              className="flex items-center gap-1 px-2 py-1 text-[10px] bg-blue-100 hover:bg-blue-200 text-blue-700 rounded font-medium transition-colors"
                              title="Renombrar"
                            >
                              <Edit3 className="w-3 h-3" />
                              Renombrar
                            </button>
                            <button
                              onClick={(e) => { e.stopPropagation(); deleteUserFolder(folder.id); }}
                              className="flex items-center gap-1 px-2 py-1 text-[10px] bg-red-100 hover:bg-red-200 text-red-700 rounded font-medium transition-colors"
                              title="Eliminar"
                            >
                              <Trash2 className="w-3 h-3" />
                              Borrar
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Mostrar mensaje si no hay contenido */}
                {filteredFiles.length === 0 && (!isDeptSection || getCurrentFolders().length === 0) ? (
                  <div className="flex flex-col items-center justify-center h-64 text-gray-400">
                    <Folder className="w-16 h-16 mb-4 opacity-50" />
                    <p className="text-lg">No hay contenido</p>
                    {isDeptSection && (
                      <button
                        onClick={openCreateFolderInCurrent}
                        className="mt-4 flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
                      >
                        <FolderPlus className="w-4 h-4" />
                        Crear primera carpeta
                      </button>
                    )}
                  </div>
                ) : filteredFiles.length > 0 && (
                  /* Lista de archivos */
                  <div>
                    <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3 flex items-center gap-2">
                      <FileText className="w-4 h-4" />
                      Archivos ({filteredFiles.length})
                    </h3>
                    <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
                      <table className="w-full">
                        <thead className="bg-gray-50 border-b border-gray-200">
                          <tr>
                            <th className="text-left px-4 py-3 text-xs font-medium text-gray-500 uppercase">Nombre</th>
                            {isGeneralSection && (
                              <th className="text-left px-4 py-3 text-xs font-medium text-gray-500 uppercase">Subido por</th>
                            )}
                            <th className="text-left px-4 py-3 text-xs font-medium text-gray-500 uppercase">Tamaño</th>
                            <th className="text-left px-4 py-3 text-xs font-medium text-gray-500 uppercase">Fecha</th>
                            <th className="text-right px-4 py-3 text-xs font-medium text-gray-500 uppercase">Acciones</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                          {filteredFiles.map((file) => {
                            const FileIcon = getFileIcon(file.type);
                            return (
                              <tr key={file.id} className="hover:bg-gray-50 transition-colors">
                                <td className="px-4 py-3">
                                  <div className="flex items-center gap-3">
                                    <div className="relative">
                                      <FileIcon className="w-5 h-5 text-gray-400" />
                                      {isGeneralSection && (
                                        <Share2 className="w-3 h-3 absolute -bottom-1 -right-1 text-orange-400" />
                                      )}
                                    </div>
                                    <span className="font-medium text-gray-900">{file.name}</span>
                                  </div>
                                </td>
                                {isGeneralSection && (
                                  <td className="px-4 py-3 text-sm text-gray-600">
                                    <span className="bg-gray-100 px-2 py-1 rounded text-xs">{file.uploadedBy || 'Sistema'}</span>
                                  </td>
                                )}
                                <td className="px-4 py-3 text-sm text-gray-500">{file.size}</td>
                                <td className="px-4 py-3 text-sm text-gray-500">
                                  {new Date(file.date).toLocaleDateString('es-ES')}
                                </td>
                                <td className="px-4 py-3 text-right">
                                  <div className="flex items-center justify-end gap-1">
                                    <button
                                      onClick={() => handleDownload(file)}
                                      className="p-1.5 hover:bg-blue-100 rounded-lg transition-colors"
                                      title="Descargar"
                                    >
                                      <Download className="w-4 h-4 text-[#3B82F6]" />
                                    </button>
                                    <button
                                      onClick={() => openRenameFileModal(file)}
                                      className="p-1.5 hover:bg-yellow-100 rounded-lg transition-colors"
                                      title="Renombrar"
                                    >
                                      <Edit3 className="w-4 h-4 text-yellow-600" />
                                    </button>
                                    <button
                                      onClick={() => handleDeleteFile(file)}
                                      className="p-1.5 hover:bg-red-100 rounded-lg transition-colors"
                                      title="Eliminar"
                                    >
                                      <Trash2 className="w-4 h-4 text-red-500" />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* Modal crear nueva carpeta */}
      {showNewFolderModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => { setShowNewFolderModal(false); setCreatingInPath(null); }}>
          <div className="bg-white rounded-xl shadow-2xl w-[400px] max-w-[90vw]" onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between p-4 border-b bg-gray-50 rounded-t-xl">
              <h3 className="text-lg font-semibold text-gray-900">Nueva carpeta</h3>
              <button onClick={() => { setShowNewFolderModal(false); setCreatingInPath(null); }} className="p-1 hover:bg-gray-200 rounded">
                <X className="w-5 h-5 text-gray-500" />
              </button>
            </div>
            <div className="p-4">
              {/* Mostrar dónde se creará */}
              {creatingInPath && creatingInPath.length > 0 && (
                <div className="mb-3 p-2 bg-blue-50 rounded-lg">
                  <p className="text-xs text-blue-600">
                    Se creará dentro de: <span className="font-medium">{creatingInPath.map(p => p.name).join(' / ')}</span>
                  </p>
                </div>
              )}
              <label className="block text-sm font-medium text-gray-700 mb-2">Nombre de la carpeta</label>
              <input
                type="text"
                value={newFolderName}
                onChange={(e) => setNewFolderName(e.target.value)}
                placeholder="Ej: Mis documentos"
                className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:border-[#3B82F6]"
                autoFocus
                onKeyPress={(e) => e.key === 'Enter' && createNewFolder()}
              />
            </div>
            <div className="flex items-center justify-end gap-3 p-4 border-t bg-gray-50 rounded-b-xl">
              <button
                onClick={() => { setShowNewFolderModal(false); setCreatingInPath(null); }}
                className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={createNewFolder}
                disabled={!newFolderName.trim()}
                className="px-4 py-2 bg-[#3B82F6] text-white rounded-lg hover:bg-[#2563EB] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Crear carpeta
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal renombrar carpeta */}
      {showRenameModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => { setShowRenameModal(false); setRenamingFolder(null); }}>
          <div className="bg-white rounded-xl shadow-2xl w-[400px] max-w-[90vw]" onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between p-4 border-b bg-gray-50 rounded-t-xl">
              <h3 className="text-lg font-semibold text-gray-900">Renombrar carpeta</h3>
              <button onClick={() => { setShowRenameModal(false); setRenamingFolder(null); }} className="p-1 hover:bg-gray-200 rounded">
                <X className="w-5 h-5 text-gray-500" />
              </button>
            </div>
            <div className="p-4">
              <div className="mb-3 p-2 bg-gray-50 rounded-lg flex items-center gap-2">
                <Folder className="w-5 h-5 text-gray-400" />
                <span className="text-sm text-gray-600">{renamingFolder?.name}</span>
              </div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Nuevo nombre</label>
              <input
                type="text"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                placeholder="Nuevo nombre de la carpeta"
                className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:border-[#3B82F6]"
                autoFocus
                onKeyPress={(e) => e.key === 'Enter' && renameFolder()}
              />
            </div>
            <div className="flex items-center justify-end gap-3 p-4 border-t bg-gray-50 rounded-b-xl">
              <button
                onClick={() => { setShowRenameModal(false); setRenamingFolder(null); }}
                className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={renameFolder}
                disabled={!newName.trim() || newName === renamingFolder?.name}
                className="px-4 py-2 bg-[#3B82F6] text-white rounded-lg hover:bg-[#2563EB] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Renombrar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal renombrar archivo */}
      {showRenameFileModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => { setShowRenameFileModal(false); setRenamingFile(null); }}>
          <div className="bg-white rounded-xl shadow-2xl w-[400px] max-w-[90vw]" onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between p-4 border-b bg-gray-50 rounded-t-xl">
              <h3 className="text-lg font-semibold text-gray-900">Renombrar archivo</h3>
              <button onClick={() => { setShowRenameFileModal(false); setRenamingFile(null); }} className="p-1 hover:bg-gray-200 rounded">
                <X className="w-5 h-5 text-gray-500" />
              </button>
            </div>
            <div className="p-4">
              <div className="mb-3 p-2 bg-gray-50 rounded-lg flex items-center gap-2">
                <File className="w-5 h-5 text-gray-400" />
                <span className="text-sm text-gray-600 truncate">{renamingFile?.name}</span>
              </div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Nuevo nombre</label>
              <input
                type="text"
                value={newFileName}
                onChange={(e) => setNewFileName(e.target.value)}
                placeholder="Nuevo nombre del archivo"
                className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:border-[#3B82F6]"
                autoFocus
                onKeyPress={(e) => e.key === 'Enter' && renameFile()}
              />
            </div>
            <div className="flex items-center justify-end gap-3 p-4 border-t bg-gray-50 rounded-b-xl">
              <button
                onClick={() => { setShowRenameFileModal(false); setRenamingFile(null); }}
                className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={renameFile}
                disabled={!newFileName.trim() || newFileName === renamingFile?.name}
                className="px-4 py-2 bg-[#3B82F6] text-white rounded-lg hover:bg-[#2563EB] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Renombrar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
